import React, { useEffect, useState } from "react";
import { Modal } from "@mui/material";
import { InfoText, ModalWrapper, TitleText, TitleWrapper, ButtonRow, Expandable, StyledBackdrop } from "./Styled";
import { api } from "../../../../shared/hooks/api";
import CustomTable from "../../../../shared/components/CustomTable";
import { Material } from "../../../../data/entities";
import SearchBarWithSuggestion from "../../../../shared/components/SearchBar/SearchBarWithSuggestion";
import { sum } from "lodash";
import { StyledButton } from "../../../../shared/styled/TitleBar";
import { MaterialRow, MaterialTableColumns } from "../MaterialList";

interface AddMaterialModalProps {
    selectedMaterials: Material[];
    open: boolean;
    handleClose: any;
    mergeMaterialRequest: Function;
    useOtherMaterials?: boolean;
}

export const AddMaterialModal = ({ selectedMaterials, open, handleClose, mergeMaterialRequest, useOtherMaterials }: AddMaterialModalProps) => {
    const [isOpen, setIsOpen] = useState(open);
    const materialsEndpoint = useOtherMaterials
        ? `/materials/other-materials/`
        : `/materials?is_active=true&page_size=${Number.MAX_SAFE_INTEGER}`;
    const [{ data, variables, error }, fetchMaterials] = api.get(
        materialsEndpoint,
        undefined,
        true
    );
    const [selectedItems, setSelectedItems] = useState<Material[]>(selectedMaterials);

    const materials = data && data.results ? data.results : [];
    const summaryMaterial = {
        id: `Tổng ${selectedItems.length} sản phẩm`,
        name: "Subtotal",
        price: sum(selectedItems.map((item: any) => (item.provider_price || 0) * (item.missing_quantity || 0))),
        isSummary: true,
    };
    const tableItems = selectedItems.length === 0 ? [] : [...selectedItems, summaryMaterial];


    const removeSelectedItem = (removedItem: Material) => {
        const removedSelectedItems = selectedItems.filter(
            (selectedItem: Material) => selectedItem.name !== removedItem.name
        );
        setSelectedItems(removedSelectedItems);
    };

    const updateItemSelectedQuantity = (id: number, selectedQuantity: number) => {
        const updatedSelectedItems = selectedItems.map((material: any) => {
            if (material.id === id) return { ...material, missing_quantity: selectedQuantity };
            return material;
        });
        setSelectedItems(updatedSelectedItems);
    };

    const handleOnclickItem = (item: Material, isAdded: boolean) => {
        const isItemContained = selectedItems.some((selectedItem) => selectedItem.name === item.name);
        if (isAdded && !isItemContained) {
            setSelectedItems([...selectedItems, item]);
        } else if (!isAdded && isItemContained) {
            removeSelectedItem(item);
        }
    };

    const onClickAddMaterials = () => {
        mergeMaterialRequest({ materials: selectedItems });
        handleClose();
    };

    const onChangeProvider = (id: string, provider: any) => {
        const updatedMaterials = selectedItems.map((material: any) => {
            if (material.id === id) {
                const selectedProvider = material.providers.find((p: any) => p.provider.name === provider.provider.name);
                return {
                    ...material,
                    provider_name: provider.provider.name,
                    provider_price: selectedProvider ? selectedProvider.price : 0,
                };
            }
            return material;
        });
        setSelectedItems(updatedMaterials);
    };

    const handleCloseWithAnimation = () => {
        setIsOpen(false);
        setTimeout(handleClose, 200);
    };

    useEffect(() => {
        if (open) {
            setIsOpen(true);
        } else {
            const timer = setTimeout(() => setIsOpen(false), 200);
            return () => clearTimeout(timer);
        }
    }, [open]);

    return (
        <Modal
            open={open}
            onClose={handleCloseWithAnimation}
            closeAfterTransition
            BackdropComponent={StyledBackdrop}
            BackdropProps={{
                timeout: 500,
                onClick: (e) => e.stopPropagation(),
            }}
        >
            <ModalWrapper isOpen={isOpen}>
                <Expandable>
                    <TitleWrapper>
                        <TitleText>Thêm vật tư</TitleText>
                        <InfoText>Vui lòng lựa chọn vật tư</InfoText>
                    </TitleWrapper>

                    <SearchBarWithSuggestion
                        menuList={materials}
                        selectedItems={selectedItems}
                        fetchItems={(variables: any) =>
                            fetchMaterials({
                                ...variables,
                                //page_size: totalItems,
                            })
                        }
                        handleOnclickItem={handleOnclickItem}
                    />

                    <CustomTable
                        itemList={tableItems}
                        RowElement={MaterialRow}
                        TableColumns={MaterialTableColumns}
                        extraRowProps={{
                            removeItem: removeSelectedItem,
                            onChangeMaterialRequestQuantity: updateItemSelectedQuantity,
                            onChangeProvider,
                        }}
                        containerStyle={{ maxHeight: "400px" }}
                    />
                </Expandable>

                <ButtonRow>
                    <StyledButton onClick={handleCloseWithAnimation}>Huỷ bỏ</StyledButton>
                    <StyledButton variant="contained" onClick={onClickAddMaterials}>
                        Lưu vật tư
                    </StyledButton>
                </ButtonRow>
            </ModalWrapper>
        </Modal>
    );
};
